import styled from 'styled-components'
import { rem } from 'polished'
import Sheet from 'components/utils/Sheet'
import TextButton from 'LuxKit/Button/TextButton'
import {
  CHAT_DEFAULT_WIDTH, CHAT_MAX_WIDTH, CHAT_MIN_WIDTH, RIGHT_PANEL_MIN_WIDTH,
  LEFT_PANE_WIDTH_VAR, SHOW_ON_MAP_ZOOM,
} from '../components/constants'

export {
  CHAT_DEFAULT_WIDTH,
  CHAT_MAX_WIDTH,
  CHAT_MIN_WIDTH,
  RIGHT_PANEL_MIN_WIDTH,
  LEFT_PANE_WIDTH_VAR,
  SHOW_ON_MAP_ZOOM,
} from '../components/constants'

export const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`

export const ContentWrapper = styled.div`
  --right-panel-min-width: ${rem(RIGHT_PANEL_MIN_WIDTH)};

  display: grid;
  grid-template-columns: 1fr;
  flex: 1;
  min-height: 0;
`

export const MainContent = styled.div`
  display: grid;
  grid-template-columns:
    clamp(
      ${rem(CHAT_MIN_WIDTH)},
      var(${LEFT_PANE_WIDTH_VAR}),
      max(
        ${rem(CHAT_MIN_WIDTH)},
        min(${rem(CHAT_MAX_WIDTH)}, calc(100% - var(--right-panel-min-width)))
      )
    )
    0
    1fr;
  min-height: 0;
  height: 100%;
  overflow-x: auto;
`

export const ChatColumnLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  border-right: 1px solid ${props => props.theme.palette.neutral.default.four};
`

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: ${rem(RIGHT_PANEL_MIN_WIDTH)};
  height: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  position: relative;
  overflow: hidden;
`

export const FullHeightMapWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  height: 100%;
  overflow: hidden;
`

export const MapArea = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  height: 100%;
  overflow: hidden;

  /* Force the ChatMapWidget to fill this container absolutely */
  & > .fill-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100% !important;
  }
`

export const MapOverlayStack = styled.div`
  position: absolute;
  top: ${rem(12)};
  left: ${rem(12)};
  right: ${rem(12)};
  z-index: 6;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(8)};
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`

export const MapUpdatingIndicatorPill = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${rem(12)};
  padding: 0 ${rem(13)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${props => props.theme.borderRadius.round};
  box-shadow: ${props => props.theme.shadow.flat.small};
  height: ${rem(44)};
  pointer-events: none;
`

export const SearchThisAreaButton = styled(TextButton)`
  box-shadow: ${props => props.theme.shadow.flat.small};
`

export const RightPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${rem(12)} ${rem(16)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.six};
  background: ${props => props.theme.palette.neutral.default.eight};
  flex-shrink: 0;

  && fieldset > div {
    grid-auto-columns: 1fr;
  }
`

export const RightPanelContent = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const EmptyStateWrapper = styled(Sheet)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const DayItineraryOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: ${props => props.theme.palette.neutral.default.eight};
`

export const InputWrapper = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  width: 100%;
  min-width: 0;
  padding: ${rem(16)} ${rem(16)} ${rem(12)} ${rem(16)};
`

export const LandingPageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${rem(20)} 0;
  flex: 1;
  min-height: 0;
`
